// extracted by mini-css-extract-plugin
export default {"seoCrossLinks":"seoCrossLinks__YWFkO","title":"title__ZTg2Z","list":"list__MzVlN","link":"link__ZmIwN"};